const $ = window.jQuery;

const languageChooser = {
    init: () => {
        const widthWindow = $(window).width();
        const containerLanguage = $(".choose-lang-select");
        if ($(".choose-lang-select").length) {

            if (widthWindow <= 991) {

                $('.choose-lang-select option').each(function() {
                    if ($(this).is(':selected')) {
                        $(this).attr('disabled', 'disabled');
                    }

                });

                containerLanguage.select2({
                    dropdownCssClass: "chooselang-container",
                    dropdownParent: $('.modal')
                });

                $(".select2-selection__rendered").on("click", function() {

                    $(".modal").addClass("openmodal");
                })


            } else {
                containerLanguage.select2({
                    dropdownCssClass: "chooselang-container",
                });
            }



            containerLanguage.on('select2:open', function(e){
                $(document.body).find('.select2-dropdown').addClass('animate-dropdown');
            }).on('select2:closing', function(e){
                $(document.body).find('.select2-dropdown').removeClass('animate-dropdown');
            });

            containerLanguage.on('select2:select', function(e) {
                var data = e.params.data;
                var url = $(data.element).data('url');
                document.location.href = url;
            })

        }

    }
}

export default languageChooser;